export default __webpack_public_path__ + "static/media/V1.36134384.png";